module.exports = __webpack_public_path__ + "img/iso6336-5-2003_fig08.0cdce467.png";